module.exports = "../../static/img/exclamation.1746616.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/exclamation.png
// module id = 190
// module chunks = 1